export enum MultiFieldImageSource {
	None,
	Gallery,
	Upload
}
